import { NotificationModule } from '@progress/kendo-angular-notification';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { MenuModule } from '@progress/kendo-angular-menu';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { StateAsideMenu } from '@global-state/state-aside-menu/state-aside-menu';
import { ErrorHandlerService } from '@services/error-handler/error-handler.service';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment } from '@environment/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserService } from '@module-user/services/user/user.service';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ApiCredentialsInterceptor } from '@services/api-credentials/api-credentials.interceptor';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { SessionTimeoutService } from '@services/session-timeout/session-timeout.service';
import { ModuleClaims } from '@module-claims/module-claims';

import 'hammerjs';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MenuModule,
    NgxsModule.forRoot([StateAsideMenu]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    DialogModule,
    NotificationModule,
    AuthModule.forRoot({
      domain: environment.auth.auth0Domain,
      clientId: environment.auth.auth0Client,
      errorPath: '/login',
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        audience: environment.auth.audience,
        redirect_uri: window.location.origin
      },
      httpInterceptor: {
        allowedList: [
          `${environment.apiServicesUrl}/*`,
          {
            uriMatcher: (uri) =>
              uri.startsWith(`${environment.api}/`) &&
              !uri.startsWith(`${environment.api}/public/`)
          }
        ]
      }
    }),
    DateInputsModule,
    InputsModule,
    IndicatorsModule,
    ModuleClaims
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiCredentialsInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US'
    },
    {
      provide: ICON_SETTINGS,
      useValue: { type: 'font' }
    },
    UserService,
    AuthenticationService,
    SessionTimeoutService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
